import * as React from "react";

import { KlaviyoIdentifiersContextProvider } from "./KlaviyoIdentifiers/provider";
import { RuntimeActiveStateContextProvider } from "./RuntimeActiveState/provider";

export function RuntimeContexts({ children }: React.PropsWithChildren) {
  return (
    <RuntimeActiveStateContextProvider>
      <KlaviyoIdentifiersContextProvider>
        {children}
      </KlaviyoIdentifiersContextProvider>
    </RuntimeActiveStateContextProvider>
  );
}
